module.exports = __webpack_public_path__ + "static/img/test.a774236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test.jpg
// module id = p6y8
// module chunks = 25